/* eslint-disable */
export default {
  // TODO- make these available elements tobe page specific and general.
  '49A5137A': {
    component_id: 'GButton',
    available_props: {
      'P_buttonId': 0,
      'P_makeSingleEvent': 'single',
      'P_buttonText': 'Button1',
      'P_buttonWidth': '100%',
      'P_buttonHeight': '100%',
      'P_fontColor': '',
      'P_fontSize': '',
      'P_fontWeight': '',
      'P_background': '',
      'P_padding': '',
      'P_disabled': 0,
      'P_customCss' : ''
    },
  },
  '49A5137B': {
    component_id: 'GText',
    available_props: {
      'P_text': 'This is place holder text',
      'P_fontSize': '',
      'P_fontWeight': '',
      'P_fontColor': '',
      'P_textAlign': '',
      'P_customCss' : ''
    },
  },
  '49A5137C': {
    component_id: 'GSlider',
    available_props: {
      'P_title': 'Simple Slider',
      'P_min': 1,
      'P_max': 100,
      'P_step': 10,
      'P_value': 30,
      'P_vertical': 0,
      'P_disabled': 0,
    },
  },
  '49A5137D': {
    component_id: 'GImage',
    available_props: {
      'P_imageSrc': '/dynamic/images/b1/small_logo_without_text.png'
    },
  },
  '49A5137E': {
    component_id: 'GInput',
    available_props: {
      'P_value': '',
      'P_disabled': 0,
      'P_placeholder': 'Enter some text',
      'P_fontColor': 'black',
      'P_background': '#aaafa9',
      'P_fontSize': '16px',
      'P_borderColor': 'red',
      'P_padding': '5px'
    },
  },
  '49A5137F': {
    component_id: 'GList',
    available_props: {
      'P_commaSeparatedOptions': 'Apple, Banana, Orange, Mango',
      'P_Label': 'Please choose',
      'P_value': 'Apple',
      'P_disabled': 0
    },
  },
  '49A5137G': {
    component_id: 'GDateTime',
    available_props: {
      'P_format': 'hh:mm:ss A MM-DD-YYYY',
      'P_fontSize': '1rem',
      'P_fontColor': '',
      'P_fontWeight': '',
      'P_background': ''
    },
  },
  '49A5137J': {
    component_id: 'GButtonWithIcon',
    available_props: {
      'P_buttonId': 0,
      'P_makeSingleEvent': 'single',
      'P_disabled': 0,
      'P_buttonText': '',
      'P_buttonWidth': '',
      'P_buttonHeight': '',
      'P_buttonColor': '',
      'P_buttonPadding': '',
      'P_fontColor': '',
      'P_fontSize': '',
      'P_fontWeight': '',
      'P_iconName': '',
      'P_iconSize': '',
      'P_iconColor': '',
      'P_flexDirection': '',
      'P_textPlacement': '', // inner/outer
      'P_customCss' : '',
      'P_textPlacement': 'inner'
    },
  },
  '49A5137K': {
    component_id: 'GButtonWithImage',
    available_props: {
      'P_buttonId': 0,
      'P_makeSingleEvent': 'single',
      'P_disabled': 0,
      'P_buttonText': '',
      'P_buttonWidth': '',
      'P_buttonHeight': '',
      'P_buttonColor': '',
      'P_buttonPadding': '',
      'P_fontColor': '',
      'P_fontSize': '',
      'P_fontWeight': '',
      'P_imgSrc': '',
      'P_imgWidth': '',
      'P_imgHeight': '',
      'P_flexDirection': '',
      'P_customCss' : ''
    },
  },
  '49A5137L': {
    component_id: 'GShutdownButton',
    available_props: {
      'P_buttonId': 0,
      'P_makeSingleEvent': 'single',
      'P_disabled': 0,
      'P_buttonText': '',
      'P_customCss' : ''
    },
  },
  '49A5137M': {
    component_id: 'GPrivacyButton',
    available_props: {
      'P_buttonId': 0,
      'P_makeSingleEvent': 'single',
      'P_disabled': 0,
      'P_buttonText': ''
    },
  },
  '49A5137N': {
    component_id: 'GMicPanel',
    available_props: {
      'P_buttonOneId': 0,
      'P_buttonOneMakeSingleEvent': 'single',
      'P_buttonTwoId': 0,
      'P_buttonTwoMakeSingleEvent': 'multiple',
      'P_buttonThreeId': 0,
      'P_buttonThreeMakeSingleEvent': 'multiple',
      'P_disabled': 0
    },
  },
  '49A5137N-1': {
    component_id: 'GMicPanel2',
    available_props: {
      'P_buttonOneId': 0,
      'P_buttonOneMakeSingleEvent': 'single',
      'P_buttonTwoId': 0,
      'P_buttonTwoMakeSingleEvent': 'multiple',
      'P_buttonThreeId': 0,
      'P_buttonThreeMakeSingleEvent': 'multiple',
      'P_disabled': 0,
      'P_text': ""
    },
  },
  '49A5137O': {
    component_id: 'GSoundPanel2',
    available_props: {
      'P_buttonOneId': 0,
      'P_buttonOneMakeSingleEvent': 'single',
      'P_buttonTwoId': 0,
      'P_buttonTwoMakeSingleEvent': 'multiple',
      'P_buttonThreeId': 0,
      'P_buttonThreeMakeSingleEvent': 'multiple',
      'P_disabled': 0,
      'P_text': ""
    }
  },
  '49A5137O-1': {
    component_id: 'GSoundPanel',
    available_props: {
      'P_buttonOneId': 0,
      'P_buttonOneMakeSingleEvent': 'single',
      'P_buttonTwoId': 0,
      'P_buttonTwoMakeSingleEvent': 'multiple',
      'P_buttonThreeId': 0,
      'P_buttonThreeMakeSingleEvent': 'multiple',
      'P_disabled': 0,
      'P_fontColor': "white",
      'P_fontSize': "",
      'P_fontWeight': "",
      'P_text': ""
    }
  },
  '49A5137P': {
    component_id: 'GDeviceName',
    available_props: {
      'P_fontSize': '',
      'P_fontWeight': '',
      'P_fontColor': '',
    },
  },
  '49A5127Q': {
    component_id: 'GQRCodeLogin',
    available_props: {
      'P_size': '300',
      'P_logo': '',
      'P_color': '#000000FF',
      'P_backgroundColor': '#FFFFFFFF',
      'P_borderColor': '#FF0000FF',
      'P_paintInnerCornerSquares': '1',
      'P_customCss' : ''
    },
  },
  '49A5137Q': {
    component_id: 'GCloseButton',
    available_props: {
      'P_disabled': 0,
      'P_buttonId': 15,
      'P_makeSingleEvent': 'single'
    }
  },
  '49A5156Q': {
    component_id: 'GCamPrivacyButton',
    available_props: {
      'P_disabled': 0,
      'P_buttonId': 15,
      'P_makeSingleEvent': 'single',
      'P_buttonText': ''
    }
  },
  '49A5137R': {
    component_id: 'GCameraControl',
    available_props: {
      'P_buttonHomeId': 51,
      'P_buttonHomeMakeSingleEvent': 'single',
      'P_buttonUpId': 52,
      'P_buttonUpMakeSingleEvent': 'multiple',
      'P_buttonRightId': 53,
      'P_buttonRightMakeSingleEvent': 'multiple',
      'P_buttonDownId': 54,
      'P_buttonDownMakeSingleEvent': 'multiple',
      'P_buttonLeftId': 55,
      'P_buttonLeftMakeSingleEvent': 'multiple',
    }
  }
}



// WEBPACK FOOTER //
// ./src/watchdog_includes/c11SupportedGraphicalElements.js